export default [
  {title: '名称',width:200 ,dataIndex: 'name'},
  {title: '应用ID',width:220 ,dataIndex: 'appId'},
  {title: '密钥',width:650 ,dataIndex: 'appSecretEnc', scopedSlots: { customRender: 'appSecretEnc'}},
  {title: '通知地址',width:250,dataIndex: 'notifyUrl'},
  {title: '操作',dataIndex: 'action', width:200 , scopedSlots: { customRender: 'action'}}
]
